var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._b({attrs:{"items":_vm.formattedUserRoles,"append-icon":"mdi-magnify","loading":_vm.isLoading,"disabled":_vm.isLoading},model:{value:(_vm.chosenUserRole),callback:function ($$v) {_vm.chosenUserRole=$$v},expression:"chosenUserRole"}},'v-autocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }